import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=07543285&scoped=true&lang=pug&"
import script from "./Chat.vue?vue&type=script&lang=ts&"
export * from "./Chat.vue?vue&type=script&lang=ts&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=07543285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07543285",
  null
  
)

export default component.exports